<template>
  <InstallmentTerminal
    v-if="hasInstallments"
      :paymentType="paymentType"
    ></InstallmentTerminal>
  <BasicTerminal v-else :paymentType="paymentType"></BasicTerminal>
</template>

<script>
import AuthMixin from '@/mixins/auth'
import StoreMixin from '@/store/mixin'

import BasicTerminal from '@/components/terminal/Basic.vue'
import InstallmentTerminal from '@/components/terminal/Installment.vue'

export default {
  components: {BasicTerminal, InstallmentTerminal},

  mixins: [AuthMixin, StoreMixin],

  props: {
    paymentType: String
  },

  computed: {
    /**
     * Determine if installments are allowed
     *   For FAPS (processor 3) with has_recurring_options or has_installment_options
     *   For PNX (processor 6) with has_installment_options permission
     */
    hasInstallments () {
      const hasFapsPermissions = this.hasPermission('has_recurring_options') || this.hasPermission('has_installment_options')
      const hasPnxPermissions = this.hasPermission('has_installment_options') && this.hasPermission('can_manage_schedules')

      const cardHasFaps = this.terminalsCardProcessors.includes(3)
      const cardHasPnx = this.terminalsCardProcessors.includes(6)
      const achHasFaps = this.terminalsACHProcessors.includes(3)
      const achHasPnx = this.terminalsACHProcessors.includes(6)

      if (this.$route.name === 'ChargeCard') {
        return (hasFapsPermissions && cardHasFaps) || (hasPnxPermissions && cardHasPnx)
      }
      if (this.$route.name === 'ChargeACH') {
        return (hasFapsPermissions && achHasFaps) || (hasPnxPermissions && achHasPnx)
      }
      return false
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/VirtualTerminal.vue